module.exports = __webpack_public_path__ + "media/images/clients/watches-f27b0b7ddd1a69890d52cf5b97cfe85c.svg";